import { render, staticRenderFns } from "./FacilityDetail.vue?vue&type=template&id=7ac478b0"
import script from "./FacilityDetail.vue?vue&type=script&lang=ts"
export * from "./FacilityDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports